import { Component, OnInit } from '@angular/core';
import * as FileSaver from 'file-saver';
import { approveMovementVm } from 'src/app/models/approveMovementVm';
import { MovementDto } from 'src/app/models/MovementDto';
import { NotificationType } from 'src/app/models/notification.message';
import { RequestApprovalDto } from 'src/app/models/requestapproval-dto';
import { MovementJDDto } from 'src/app/models/requests/MovementJDDto';
import { MovementJDVM } from 'src/app/models/requests/MovementJDVM';
import { MovementService } from 'src/app/services/movement.service';
import { MovementapprovalService } from 'src/app/services/movementapproval.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';

@Component({
  selector: 'app-view-approvedmovement',
  templateUrl: './view-approvedmovement.component.html',
  styleUrls: ['./view-approvedmovement.component.css']
})
export class ViewApprovedmovementComponent implements OnInit {

  ViewManPowerVisible = false;
  MovementJD: MovementJDDto[] | undefined;
  ApproveRequest: MovementDto | any
  movementApprovals: RequestApprovalDto[] | undefined;
  currentUser: any;
  approvedMovement: MovementDto[] | any;
  PathReportString:string="";
  canViewDocument: boolean = false;
  pdf:string="";
  receivedfile: string = "";
  ismovementpprovalModalVisible = false
  showCreatedByColumn: boolean = false;
  showFunctionColumn: boolean = false;
  constructor(private movementService: MovementService, private notification: NotificationService,
    private tokenService: TokenService, private movementApprovalService:MovementapprovalService) { }

    
  Movement: MovementDto[] | any;
  Comment: string = '';
  ngOnInit(): void {
    this.loadRecords();
  }

  
  async loadRecords() {
    
    ;

    let resMovement = await this.movementService.MyApprovedManpowerRequests().toPromise();
    this.approvedMovement = <MovementDto[]>resMovement.responseData;
;
  }

  
  handleCancel(): void {
    this.ismovementpprovalModalVisible = false;
   
  }
  async approveMovement() {
   // this.isManPowerpprovalModalVisible = true;
      ; 
      const model: approveMovementVm = { id: this.ApproveRequest.id,  message: this.Comment };
      
       this.movementService.approveMovement(model).subscribe({
         next: (data => {
           
           if (data.responseCode == "00") {
             this.notification.sendMessage({
               message: data.message,
               type: NotificationType.success
             });

             this.loadRecords();
             this.close()
           }
           else {

             this.notification.sendMessage({
             message: data.message,
               type: NotificationType.error
             });

           }

         }),
         error: ((error: any) => {
           console.log(error.error);
           ;


           this.notification.sendMessage({
             message: error.error.message,
             type: NotificationType.error
           });
         })

       });

  }

   async getJD(datas: MovementDto) {
     // this.ViewManPowerVisible = true;
  ;
      this.ApproveRequest = datas;
      let getJDRequest = await this.movementService.GetJDForRequest(datas.id).toPromise();
      ;
   
      this.MovementJD = <MovementJDDto[]>getJDRequest.responseData;
      var pdfFile = getJDRequest.responseData[0].documentContent;
      if(pdfFile.includes("data:application/pdf;base64")){
        var receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/pdf;base64," , "")

        const b = Uint8Array.from(atob(receivedfile), c => c.charCodeAt(0));
        const blob = new Blob([b] , {type: "application/octet-stream"});
        FileSaver.saveAs(blob, getJDRequest.responseData[0].documentName);
   
      }
    
    var receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," , "")
    const b = Uint8Array.from(atob(receivedfile), c => c.charCodeAt(0));
    const blob = new Blob([b] , {type: "application/octet-stream"});
    FileSaver.saveAs(blob, getJDRequest.responseData[0].documentName);

   }
   

  async rejectMovement() {

    if (this.Comment === '') {
      this.notification.sendMessage({
        message: 'Comment is required when rejecting Man Power request',
        type: NotificationType.error
      });
    }
    else {
      

        this.close();

        const model: approveMovementVm = { id: this.ApproveRequest.id, message: this.Comment  };

        this.movementService.rejectMovement(model).subscribe({
          next: (data => {

            if (data.responseCode == "00") {
              this.notification.sendMessage({
                message: data.message,
                type: NotificationType.success
              });

              this.loadRecords();
              this.close();
            }
            else {

              this.notification.sendMessage({
                message: data.message,
                type: NotificationType.error
              });

            }

          }),
          error: ((error: any) => {
            console.log(error.error);
            ;


            this.notification.sendMessage({
              message: error.error.message,
              type: NotificationType.error
            });
          })

        });
    
    }
  }

  
  async showDocument(datas: MovementDto){
    // this.open();
    ;
    let getJDRequest = await this.movementService.GetJDForRequest(datas.id).toPromise();
       ;
     
       this.MovementJD = <MovementJDDto[]>getJDRequest.responseData;
     
        this.receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/pdf;base64," , "")
        this.pdf = getJDRequest.responseData[0].documentContent
     
      //  this.PathReportString = 'data:application/pdf;base64,' + (this.sanitizer.bypassSecurityTrustResourceUrl(this.receivedfile) as any).changingThisBreaksApplicationSecurity;
              
       // top!.document.getElementById('ifrm')!.setAttribute("src", this.PathReportString)!;
       const pdfWindow = window.open("")!;    
       pdfWindow.document.write("<html<head><title>Additional Report</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");    
       pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " +    
       encodeURI(this.receivedfile) + "#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>") 
   
   
   }



  async open(datas: MovementDto) {
    this.canViewDocument = false;
    this.ViewManPowerVisible = true;
;
    this.ApproveRequest = datas;
    let getJDRequest = await this.movementService.GetJDForRequest(datas.id).toPromise();
    this.MovementJD = <MovementJDDto[]>getJDRequest.responseData;
    if (this.MovementJD.length > 0) {  this.canViewDocument = true }
    let resApprovals = await this.movementApprovalService.getRequestApprovals(datas.id).toPromise();
    this.movementApprovals = <RequestApprovalDto[]>resApprovals.responseData;

  }

  close(): void {
    this.ViewManPowerVisible = false;
  }

  cancel(): void {
 return;
  }
 
  confirm(): void {
    alert('click confirm');
  }



}
